import React, { useState } from "react";
import { ReactComponent as WebsiteSVG } from "images/icons/website-svgrepo-com.svg";
import { ReactComponent as TasksSVG } from "images/icons/tasks-app-svgrepo-com 1.svg";
import { ReactComponent as MoneySVG } from "images/icons/money-svgrepo-com 1.svg";
import { ReactComponent as QrCodeSVG } from "images/icons/qr-code-svgrepo-com 3.svg";
import { ReactComponent as GearsSetupSVG } from "images/icons/gears-setup-svgrepo-com 1.svg";
// Background
import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";
import "./RequestDemoPage.css";
import axios from "axios";
// import PageHeader from "components/PageHeader/TitleSubtitlePageHeader";
import RequestAMemo from "components/PageHeader/TitleSubtitlePageHeader/RequestAMemo";
import { getData } from "app/data";
import { rootUrl } from "config/setting";
import { FormattedMessage } from "react-intl";
import { useLocation } from 'react-router-dom';

export default function Index() {
  const location = useLocation();
  const pathName = location.pathname.split("/")[1];
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, company, phone, location, service, country, message } =
      e.target.elements;
    let details = {
      "your-name": name.value,
      "your-email": email.value,
      "your-company": company.value,
      "your-phone": phone.value,
      "your-location": location.value,
      "your-service": service.value,
      "your-country": country.value,
      "your-message": message.value,
    };
    const form = new FormData();
    for (const field in details) {
      form.append(field, details[field]);
    }
    axios
      .post(
        `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/450/feedback`,

        form,
        { headers: { "content-type": "multipart/form-data" } }
      )
      .then(function (response) {
        console.log(response);
        setIsSent(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <>
      <div className="rqp-wrapper">
        {pathName !== "request-a-demo" ? null : <RequestAMemo
          title="request_a_free_demo"
          subtitle="risk_free_text"
          subtitleColorGreen={true}
        />}

        <div className="rqp-for-background"></div>
        <div className="container">
          <div className="rqp-container row">
            {!isSent ? (
              <>
                <div className="col-lg-6">
                  <div className="rqp__form-container">
                    <form onSubmit={handleSubmit}>
                      <div className="rqp__form-container__inputs">
                        <h2>
                          <FormattedMessage id="lets_chat" />
                        </h2>
                        <input
                          type="text"
                          placeholder="Your Name*"
                          id="name"
                          name="your-name"
                        // required
                        />
                        <input
                          type="text"
                          placeholder="Email Address*"
                          id="email"
                          name="your-email"
                        // required
                        />
                        <input
                          type="text"
                          placeholder="Phone Number*"
                          id="phone"
                          name="your-phone"
                        />
                        <input
                          type="text"
                          placeholder="Company / Business*"
                          id="company"
                          name="your-company"
                        />
                        <input
                          type="text"
                          placeholder="Number of Locations"
                          id="location"
                          name="your-location"
                        // required
                        />
                        <select
                          placeholder="I'm interested in"
                          id="service"
                          name="your-service"
                          defaultValue="default"
                        >
                          <option value="default" disabled>
                            {getData("requestADemoData").form.im_interested_in}
                          </option>
                          <option>
                            {getData("requestADemoData").form.online_ordering_solution}
                          </option>
                          <option>
                            {getData("requestADemoData").form.delivery_robots}
                          </option>
                          <option>
                            {getData("requestADemoData").form.restaurant_automation}
                          </option>
                          <option>
                            {getData("requestADemoData").form.photography_service}
                          </option>
                          <option>
                            {getData("requestADemoData").form.merchant_service}
                          </option>
                          <option>
                            {getData("requestADemoData").form.commercial_equipment_leasing}
                          </option>
                        </select>
                        <select
                          placeholder="Country"
                          id="country"
                          name="your-country"
                          defaultValue="default"
                        >
                          <option
                            value="default"
                            disabled
                            className="gray"
                          >
                            {getData("requestADemoData").form.country}
                          </option>
                          <option value="canada">
                            {getData("requestADemoData").form.canada}
                          </option>
                          <option value="not_canada">
                            {getData("requestADemoData").form.not_canada}
                          </option>
                        </select>
                        <textarea
                          type="text"
                          placeholder="Additional comments"
                          id="message"
                          name="your-message"
                        />
                        <button
                          id="btnFlexFix"
                          className="custom-btn green-button"
                          type="submit"
                        >
                          <FormattedMessage id={"request_a_demo"} />
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="rqp-contact-from-info">
                    <p>
                      <FormattedMessage id={"request_free_demo_form_notice"} />
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <div className="rqp-thanks-message col">
                <div className="text-wrapper">
                  <h2>
                    <FormattedMessage
                      id={"request_free_demo_form_submitted_title"}
                    />
                  </h2>
                  <p>
                    <FormattedMessage
                      id={"request_free_demo_form_submitted_text"}
                    />
                  </p>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <div className="rqp__text-container">
                <h2>
                  <FormattedMessage id={"request_free_demo_benefit_title"} />
                </h2>
                <div className="rqp-list-box">
                  <div>
                    <WebsiteSVG className="rqp-icon" />
                    <p>
                      <FormattedMessage
                        id={"request_free_demo_benefit_list1"}
                      />
                    </p>
                  </div>

                  <div>
                    <TasksSVG className="rqp-icon" />
                    <p>
                      <FormattedMessage
                        id={"request_free_demo_benefit_list2"}
                      />
                    </p>
                  </div>
                  <div>
                    <MoneySVG className="rqp-icon" />
                    <p>
                      <FormattedMessage
                        id={"request_free_demo_benefit_list3"}
                      />
                    </p>
                  </div>
                  <div>
                    <QrCodeSVG className="rqp-icon" />
                    <p>
                      <FormattedMessage
                        id={"request_free_demo_benefit_list4"}
                      />
                    </p>
                  </div>
                  <div>
                    <GearsSetupSVG className="rqp-icon" />
                    <p>
                      <FormattedMessage
                        id={"request_free_demo_benefit_list5"}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rqp-background">
          <RightBg className="background-left-bg" />
          <RightBg className="background-right-bg" />
        </div>
        <hr />
      </div>
    </>
  );
}
